// extracted by mini-css-extract-plugin
module.exports = {"noBackgroundIcon":"ProfileDocumentsPrivacySecurity_noBackgroundIcon__Cfqbd","icon":"ProfileDocumentsPrivacySecurity_icon__gm32V"};